module.exports = __webpack_public_path__ + "static/media/Blackpool.9e1cff0d.jpg";